<template>
  <div class="row">
    <div class="col-xs-10">
      <div class="col-xs-4">
        <label class="required">Author First name</label>
        <input class="form-control input-sm" v-model="author.first_name" placeholder="First name" :disabled="disabled"/>
      </div>
      <div class="col-xs-4">
        <label class="required">Author Last name</label>
        <input class="form-control input-sm" v-model="author.last_name" placeholder="Last name" :disabled="disabled" />
      </div>
      <div class="col-xs-4">
        <label class="">Author ORCID ID</label>
        <input class="form-control input-sm" v-model="author.orcid" placeholder="ORCID ID" :disabled="disabled"/>
      </div>
    </div>
    <div class="col-xs-2" style="margin: 25px 0">
      <button v-if="!disabled" class="btn btn-xs btn-outline btn-danger" v-on:click="removeAuthor($event, index)"><i class="fa fa-remove"></i> Delete</button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Authors',
  props: ['author', 'removeAuthor', 'index', 'disabled']
}
</script>



// WEBPACK FOOTER //
// src/components/user/Authors.vue